import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["search", "row", "body", "sortButton", "showAll", "count", "empty"];
  static values = { limit: Number };

  connect () {
    this.sortKey = "leads";
    this.direction = "desc";
    this.expanded = false;
    this.refresh();
  }

  filter () {
    this.refresh();
  }

  showAll () {
    this.expanded = !this.expanded;
    this.refresh();
  }

  sort (event) {
    const key = event.currentTarget.dataset.sortKey;
    this.direction = key === this.sortKey ? (this.direction === "desc" ? "asc" : "desc") : (key === "name" ? "asc" : "desc");
    this.sortKey = key;
    this.rowTargets.slice().sort((a, b) => {
      const order = key === "name" ? a.dataset.name.localeCompare(b.dataset.name) : Number(a.dataset[key]) - Number(b.dataset[key]);
      return (this.direction === "asc" ? order : -order) || a.dataset.name.localeCompare(b.dataset.name);
    }).forEach(row => this.bodyTarget.appendChild(row));
    this.sortButtonTargets.forEach(button => {
      const active = button.dataset.sortKey === key;
      button.closest("th").setAttribute("aria-sort", active ? `${this.direction}ending` : "none");
      button.querySelector("[data-sort-indicator]").textContent = active ? (this.direction === "asc" ? "▲" : "▼") : "";
    });
    this.refresh();
  }

  refresh () {
    const query = this.searchTarget.value.trim().toLowerCase();
    const matches = this.rowTargets.filter(row => row.dataset.search.includes(query));
    const visible = query || this.expanded ? matches : matches.slice(0, this.limitValue);
    this.rowTargets.forEach(row => row.classList.toggle("hidden", !visible.includes(row)));
    this.emptyTarget.classList.toggle("hidden", matches.length > 0);
    this.showAllTarget.classList.toggle("hidden", Boolean(query) || matches.length <= this.limitValue);
    this.showAllTarget.textContent = this.expanded ? "Show top sources" : "Show all sources";
    this.countTarget.textContent = query ? `${matches.length} matching ${matches.length === 1 ? "source" : "sources"}` : `${this.expanded ? "All" : "Top"} ${visible.length} of ${this.rowTargets.length} sources`;
  }
}
